import React, { FC } from 'react';
import { Collapse, MinusIcon } from '@gamesb42/ui-kit';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { TrancheCustomSettings as CustomSettingsType } from 'types/TrancheTypes';
import { formatAmount } from 'helpers/formatters';

import s from './styles.module.scss';

interface TrancheCustomSettingsProps {
  customSettings?: CustomSettingsType;
  currency?: string;
}

const TrancheCustomSettings: FC<TrancheCustomSettingsProps> = ({ customSettings, currency }) => {
  const { t } = useTranslation();

  if (!customSettings?.custom_interest_enabled || !customSettings?.interest?.length) {
    return null;
  }

  return (
    <Collapse style={{ marginTop: '40px' }} collapsible="header" defaultActiveKey={['1']}>
      <Collapse.Panel header={t('forms.activationOrder.customSettings')} key="1">
        <div className={s.customSettings}>
          <div className={s.settingsRow}>
            <div className={s.settingsLeft}>{t('forms.activationOrder.customInterestEnabled')}:</div>
            <div className={s.settingsRight}>{customSettings.custom_interest_enabled ? 'Yes' : 'No'}</div>
          </div>

          {customSettings.interest && customSettings.interest.length > 0 && (
            <div className={s.interestPeriods}>
              <div className={s.periodsTitle}>{t('forms.activationOrder.interestPeriods')}:</div>
              {customSettings.interest.map((period, index) => (
                <div key={index} className={s.periodItem}>
                  <div className={s.periodRow}>
                    <div className={s.periodLeft}>Period:</div>
                    <div className={s.periodRight}>
                      {moment(period.period_from, 'YYYY-MM-DD').format('DD.MM.YYYY')} -{' '}
                      {moment(period.period_to, 'YYYY-MM-DD').format('DD.MM.YYYY')}
                    </div>
                  </div>
                  <div className={s.periodRow}>
                    <div className={s.periodLeft}>{t('forms.activationOrder.interestPercent')}:</div>
                    <div className={s.periodRight}>{period.interest}%</div>
                  </div>
                  {index < customSettings.interest.length - 1 && <div className={s.divider} />}
                </div>
              ))}
            </div>
          )}
        </div>
      </Collapse.Panel>
    </Collapse>
  );
};

export default TrancheCustomSettings;
